<template>
  <div class="toolbar-header card-header" >
    <strong class="mr-4">{{ title }}</strong>
    <a-button-group>
      <a-button
        icon="plus-circle"
        class="text-primary"
        type=""
        @click="onCreateClick"
      >
        {{ createText }}
      </a-button>
      <a-tooltip placement="top">
        <template slot="title">
          <span>Refresh Data</span>
        </template>
        <a-button @click="onRefreshClick">
          <a-icon type="sync" :spin="loadingRefresh" class="text-success" />
        </a-button>
      </a-tooltip>

      <a-tooltip placement="top" v-if="showExportButtons">
        <template slot="title">
          <span>Export Data</span>
        </template>
        <a-button @click="onExportExcel">
          <a-icon type="file-excel" class="text-success" />
        </a-button>
      </a-tooltip>

      <a-tooltip placement="top" v-if="showExportButtons">
        <template slot="title">
          <span>Print Preview</span>
        </template>
        <a-button @click="onExportPdf">
          <a-icon type="printer" class="text-success" />
        </a-button>
      </a-tooltip>
    </a-button-group>
  </div>
</template>

<script>
export default {
  name: 'ToolbarHeader',
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    createText: {
      type: String,
      default: 'Tambah',
    },
    loadingRefresh: {
      type: Boolean,
      default: false,
    },
    showExportButtons: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onCreateClick() {
      this.$emit('create')
    },
    onRefreshClick() {
      this.$emit('refresh')
    },
    onExportExcel() {
      this.$emit('export-excel')
    },
    onExportPdf() {
      this.$emit('export-pdf')
    },
  },
}
</script>

<style scoped>
.toolbar-header {
  display: flex;
  align-items: center;
}
</style>
